import React, { useEffect } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import parse from "html-react-parser";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";
import { inform_success } from "../../utils/alert";
import { checkDateRange } from "../../utils/date";
import axios from "axios";
//Material
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
//Component
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import FormInput from "../../stories/hook-controls/input";
import { MaterialUIDateTimePickers } from "./../../stories/hook-controls/datepicker/datetimepicker";
function BannerMaster() {
  const method = useForm({mode:"all"});
  const { control, setValue, setError, getValues,clearErrors } = method;
  const rich = useWatch({
    control,
    name: "CONTENT", // without supply name will watch the entire form, or ['firstName', 'lastName'] to watch both
    defaultValue: "", // default value before the render
  });
  useEffect(() => {
    (async () => {
      let res = await GetAnnouncement();
      let data = common.setDataToFormHookV2(res);
      data?.forEach(({ name, value }) => setValue(name, value));
    })();
  }, [setValue]);
  function validate() {
    clearErrors()
    let result = true;
    if (!checkDateRange(getValues().DATE_FROM, getValues().DATE_TO)) {
      setError("DATE_FROM", {
        type: "manual",
        message: `Invalid date range`,
      });
      setError("DATE_TO", {
        type: "manual",
        message: `Invalid date range`,
      });
      result = false;
    }

    return result;
  }
  async function Save() {
    if (!validate()) return;
    let param = method.getValues();
    let error = await UpdateAnnouncement(param);
    if (!error) inform_success();
  }
  return (
    <BaseContainer>
      <FormProvider {...method}>
        <BoxTemplate1 title="Edit announcement">
          <Box display="flex" pb={3}>
            <Box mr={1}>
              <MaterialUIDateTimePickers name="DATE_FROM" label="From" />
            </Box>
            <Box>
              <MaterialUIDateTimePickers name="DATE_TO" label="To" />
            </Box>
          </Box>
          <Box display="flex" height="430">
            <FormInput
              name="CONTENT"
              label="Content"
              multiline
              rows={20}
              style={{ height: "300" }}
              spellCheck={false}
            />
          </Box>
          <Button variant="contained" onClick={Save}>
            Save
          </Button>
        </BoxTemplate1>
        <br />
        <BoxTemplate1 title="Preview">
          {common.isEmptyStr(rich) ? null : parse(rich)}
        </BoxTemplate1>
      </FormProvider>
    </BaseContainer>
  );
}
//api
const GetAnnouncement = async (param) => {
  let url = `${API_URL.Job}/api/master/GetAnnouncement`;
  let { result } = await common.to(axios.post(url));
  if (result && result.data) return result.data;
};
const UpdateAnnouncement = async (param) => {
  let url = `${API_URL.Job}/api/master/UpdateAnnouncement`;
  let { result, error } = await common.to(axios.post(url, param));
  return error;
};
export default BannerMaster;
